(function () {
  const PHRASES = [
    'Search for saffron',
    'Search for ghee',
    'Search for atta',
    'Search for almond oil',
    'Search for honey',
    'Find your favorite items',
  ];

  const INTERVAL_MS = 2500;   // time each phrase stays
  const TYPE_SPEED  = 60;     // ms per character while typing
  const ERASE_SPEED = 30;     // ms per character while erasing

  function animate(input) {
    let phraseIndex = 0;
    let charIndex = 0;
    let typing = true;

    function tick() {
      // Stop animating while the user is typing
      if (document.activeElement === input && input.value.length > 0) {
        setTimeout(tick, INTERVAL_MS);
        return;
      }

      const current = PHRASES[phraseIndex];

      if (typing) {
        charIndex++;
        input.setAttribute('placeholder', current.slice(0, charIndex));
        if (charIndex === current.length) {
          typing = false;
          setTimeout(tick, INTERVAL_MS);
          return;
        }
        setTimeout(tick, TYPE_SPEED);
      } else {
        charIndex--;
        input.setAttribute('placeholder', current.slice(0, charIndex));
        if (charIndex === 0) {
          typing = true;
          phraseIndex = (phraseIndex + 1) % PHRASES.length;
        }
        setTimeout(tick, ERASE_SPEED);
      }
    }

    tick();
  }

  function init() {
    // Covers both the modal input and any other search inputs
    const inputs = document.querySelectorAll(
      '#Search-In-Modal, input.search__input[name="q"]'
    );
    inputs.forEach(animate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();